// extracted by mini-css-extract-plugin
export default {"Typing":"Typing_Typing__PkjZR","typing":"Typing_typing__9+l4G","blink-caret":"Typing_blink-caret__b33NJ","TypingLoader":"Typing_TypingLoader__wNCUN","d3":"Typing_d3__OvahV"};